<template>
  <transition name="drawer-slide" @after-enter="$emit('opened')"
              @after-leave="$emit('closed')">
    <div v-show="visible" class="v-drawer">
      <slot></slot>
      <v-shadow ref="shadow" @click="hide()" :z-index="100"></v-shadow>
    </div>
  </transition>
</template>

<script>
  import vShadow from './shadow';

  export default {
    name: 'v-drawer',
    components: {
      vShadow
    },
    data() {
      return {
        visible: false
      };
    },
    computed: {},
    mounted() {
      if (this.$el) {
        document.body.appendChild(this.$refs.shadow.$el);
      }
    },
    beforeDestroy() {
      this.$refs.shadow.$el.parentNode.removeChild(this.$refs.shadow.$el)
    },
    watch: {
      visible(val) {
        this.$refs.shadow.visible = val
      }
    },
    methods: {
      show() {
        this.visible = true;
        setTimeout(()=>{
          this.visible = false;
        },2000);
      },
      hide() {
        this.visible = false
      }
    }
  };
</script>

<style lang="scss">
  .drawer-slide-enter-active {
    opacity: 1;
    animation: drawer-slide-in .3s ease;
  }

  .drawer-slide-leave-active {
    animation: drawer-slide-out .3s ease;
  }

  @keyframes drawer-slide-in {
    0% {
      transform: translate3d(0, 100%, 0);
    }
    100% {
      transform: translate3d(0, 0, 0);
    }
  }

  @keyframes drawer-slide-out {
    0% {
      opacity:1
    }
    100% {
      opacity: 0;
    }
  }

  .v-drawer {
    box-sizing: border-box;
    transition: transform 0.3s;
    position:absolute;
    overflow-y: auto;
    background-color: white;
    top: 45%;
    z-index: 999;
    left: 25%;
    height:52px;
  }
</style>
